import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import moment from "moment";
import { format } from "date-fns";
import DateRanger from "../components-react/DateRanger";
import SelectDropdown from "../components-react/SelectDropdown";
import {
  RPTypes,
  activeInactiveStatus,
  added_not_added_to_lead,
  all_access_plan,
  approvalStatus,
  biomaxAppRegisterStatus,
  biomaxStatus,
  conversion_status_boolean,
  couple_plan_filter,
  daysAgo,
  daysAgoUptoYear,
  experience_level,
  gender,
  handoverStatuses,
  lead_btn_enable,
  leaveStatus,
  months,
  pause_status,
  paymentModesSubs,
  paymentSources,
  paymentStatus,
  paymentStatusCupon,
  payment_location,
  payment_sources,
  paymnetTypes,
  pre_gym_sales,
  price_ranges,
  ptTrialStatuses,
  pt_plan_status,
  pt_revenue_view_type,
  recurringStatus,
  regularPlanDurationsDropdwon,
  regularPlansDropdown,
  renewalFromCurrent,
  renewalFromPast,
  slot_times,
  subscriptionDays,
  subscriptionTypes,
  subscriptionTypes1,
  subscription_status,
  susbscriptionStatus,
  susbscriptionStatusBRM,
  timeSlots,
  timeSlotsQuarter,
  tmeStatus,
  transfer_type,
  trxModes,
  withinDays,
  years,
  yearsIncludingNext,
} from "../common-data/DropdowData";
import { selectAssigneeData } from "../../redux/reducers/assigneeDataSlice";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchAllAssigneeData, fetchGymData } from "../../data/APIs";
import {
  fetchAllTrainersByExpLvlData,
  fetchUserDetailsByMobileData,
} from "../../redux/reducers/apiSlice";
import {
  fetchAddonsData,
  fetchCentralisedPlansData,
  fetchInHouseUsersData,
  fetchLeadSourceData,
  fetchRegularPlansData,
  fetchTrainerShiftsData,
} from "../../redux/reducers/dropdownApiSlice";
import MultiSelect from "../components-react/MultiSelect";
import {
  fetchWorkoutCategoriesData,
  fetchWorkoutExperiencesData,
} from "../../redux/workout-reducers/workoutApis";
import SelectDropdownDynamic from "../components-react/SelectDropdownDynamic";
import RedButton from "./RedButton";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import SingleDatePicker from "../pt-trials/common/SingleDatePicker";
import CmnFilterStrctureCardBlock from "./CmnFilterStrctureCardBlock";
import { fetchIncentivesSlabsData } from "../../redux/incentives-reducers/incentivesSlice";
import {
  BiSearchIcon,
  DatePickerIcon,
  RedCrossIcon,
  WhiteBgCheckIcon,
  WhiteBgXIcon,
} from "../../images/icons/icons";
import { fetchGymLandingPagesData } from "../../redux/website-reducers/websiteSlice";

function getDateRangerLable(rangeKey, from) {
  switch (rangeKey) {
    case "subsAddDate":
      return from === "pt-flow" ? "PT Sub Add Date" : "Subscription Add Date";
    case "memberCheckinDate":
      return "Member Checkin Date";
    case "trainerCheckinDate":
      return "Trainer Last Checkin Date";
    case "regSubsAddDate":
      return "Regular Sub Add Date";
    case "memberLastCheckinDate":
      return "Member Last Checkin Date";
    case "expiredDate":
      return "Membership Expire Date";
    default:
      return "Select Date";
  }
}

const CommonFilterStructure = (props) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const assigneeData = useSelector(selectAssigneeData);

  const { allTrainerByExpLvlData, userDetailsByMobile } = useSelector(
    (state) => state.api
  );
  const { centralisedPlans, leadSources } = useSelector(
    (state) => state.dropdown
  );
  const { inhouseUsers, trainerShifts } = useSelector(
    (state) => state.dropdown
  );
  const { workoutCategoriesData, workoutExperiences } = useSelector(
    (state) => state.workoutApi
  );
  const { ptIncentivesSlabs } = useSelector((state) => state.incentives);
  const { gymLandingPagesLoading, gymLandingPagesError, gymLandingPages } =
    useSelector((state) => state.webApi);

  const {
    decryptedText,
    from,
    setFilters,
    filters,
    searchFilterApplied,
    onClickSearch,
    allPaymentOnlineData,
    allPaymentCashData,
    onClickReset,
    onClickExportBtn,
    onClickBroadcastBtn,
    handleDateRangeChange,
    rangeState,
    clearDateRanger,

    activeDateRanges,
    rangeStates,
    setActiveDateRanges,
    allSubsTbData,
    allSubsPlanStatsData,
    allMaleFemaleBurification,

    partialPaymentInfo,

    ptCardData,
    salesTodayValues,
    totalSaleData,
    totalMemberData,
    canPlanFilters,

    partialStatsData,
    targetStats,
    staffLeaveStats,
    staffLeavesStats,
    staffLeavesYearStats,
    onlySearch,
    prevGymId,
    onlyDateRanger,

    isNotAdmin,

    clickedCard,
    clickedCardAsItIs,
    isDateRanger,
    isChekboxFilters,
    isTrainers,
    isReceptionists,
    isShiftDropdown,
    trainerIdToGetShifts,
    isDisabledGym,
    otherUserLabel,
    approvalManagerFor,
    isDisabledDate,

    isURE,
    filterType,
    isLoading,
    isStatusDisabled,
    isDisableFutureDates,
    isGlobal,
    isTop,
    isReload,
    isSegment,
  } = props || {};
  const isAdmin = decryptedText?.account_type === "admin";
  const isTrainer = decryptedText?.account_type === "trainer";
  const isReceptionist = decryptedText?.account_type === "receptionist";
  const isClusterManager = decryptedText?.account_type === "cluster_manager";

  // Check if user is a manager role (cluster_manager, fitness_manager, sales_manager, club_manager)
  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(decryptedText?.account_type);

  const iniAllowedFilters = {
    isCardBlockShow: false,
    isFilterBlockShow: false,
    isSearchShow: false,
    isDateRangerShow: false,
    isMultiDateRangerShow: false,
    isChekboxFiltersShow: false,
    isGymShow: false,
    isTrainerShow: false,
    isReceptionistShow: false,
    isHandoverStatusShow: false,
    isPTTrialStatus: false,
    isStatusShow: false,
    isPaymentTypeShow: false,
    isApprovalStatusShow: false,
    isCreatorShow: false,
    isSubsTypeShow: false,
    isPlanShow: false,
    isPlanDurationShow: false,
    isTrxTypeShow: false,
    isActiveShow: false,
    isPopularShow: false,
    isBiomaxRegisterShow: false,
    isTrxModeShow: false,
    isRPTypeShow: false,
    isLastCheckedInShow: false,
    isBiomaxAppRegisterShow: false,
    isLeastCheckinInBetweenShow: false,
    isOtherUsersShow: false,
    isLeaveStatusShow: false,
    isTimeShow: false,
    isShiftShow: false,
    isSlabShow: false,
    isRecurringStatusShow: false,
    isCategoryNameShow: false,
    isPlanSuitableForShow: false,
    isPaymentSourceShow: false,
    isTwoGridSystem: false,
    isGridColsFiveSystem: false,
    isExpiringInDaysShow: false,
    isExpiredDaysAgoShow: false,
    isExportBtnShow: false,
    isRenewalFromDayShow: false,
    isRenewalFromMonthShow: false,
    isAddedByShow: false,
    isPTPlanStatusShow: false,
    isRegularSubsStatusShow: false,
    isRecuNonRecuShow: false,
    isButtonEnableShow: false,
    isAddedNotAddedToLeadFilterShow: false,
    isBiomaxRegisterStatusShow: false,
    isPaymentSlotTimeFilterShow: false,
    isSignleDateShow: false,
    isSlotTimeFilterShow: false,
    isMonthFilterShow: false,
    isYearFilterShow: false,
    isIncentiveSlabShow: false,
    isToggleFilterShow: false,
    isTrainerLastCheckinTimeShow: false,
    isTMEStatusShow: false,
    isConvertedStatusShow: false,
    isReloadBtnShow: false,
    isPTRevenueViewTypeShow: false,
    isCoupleplanFilterShow: false,
    isLeadSourceShow: false,
    isGenderShow: false,
    isTransferTypeShow: false,
    isPauseStatusShow: false,
    isBroadcastBtnShow: false,
    isExperienceLevelShow: false,
    isPaymentLocationShow: false,
    isDailyTargetPlanTypesShow: false,
    isLandingPageKeywordShow: false,
  };
  const [allowedFilters, setAllowedFilters] = useState(iniAllowedFilters);

  const [openDateRanger, setOpenDateRanger] = useState(false);
  const [activeCmnDateRanges, setCmnActiveDateRanges] = useState({
    subsAddDate: false,
    memberCheckinDate: false,
    regSubsAddDate: false,
    memberLastCheckinDate: false,
    trainerCheckinDate: false,
    expiredDate: false,
  });
  const generateInitialRangeStates = (from, clickedCard, clickedCardAsItIs) => {
    const rangeTemplate = (key) => [
      {
        startDate: null,
        endDate: null,
        key,
      },
    ];

    const rangeStates = {};

    if (from === "biomax-members") {
      rangeStates.subsAddDate = rangeTemplate("subsAddDate");
      rangeStates.memberLastCheckinDate = rangeTemplate(
        "memberLastCheckinDate"
      );
      rangeStates.trainerCheckinDate = rangeTemplate("trainerCheckinDate");
    } else if (from === "pt-flow") {
      if (clickedCard === "pt-revenue") {
        rangeStates.subsAddDate = rangeTemplate("subsAddDate");
        rangeStates.regSubsAddDate = rangeTemplate("regSubsAddDate");
      } else if (
        clickedCard === "taee" ||
        clickedCard === "total_trial_subscription"
      ) {
        rangeStates.subsAddDate = rangeTemplate("subsAddDate");
        rangeStates.memberLastCheckinDate = rangeTemplate(
          "memberLastCheckinDate"
        );
        if (clickedCardAsItIs === "expired") {
          rangeStates.expiredDate = rangeTemplate("expiredDate");
        }
      }
    } else {
      rangeStates.subsAddDate = rangeTemplate("subsAddDate");
      rangeStates.memberCheckinDate = rangeTemplate("memberCheckinDate");
    }

    return rangeStates;
  };
  const initialRangeStates = useMemo(
    () => generateInitialRangeStates(from, clickedCard, clickedCardAsItIs),
    [from, clickedCard, clickedCardAsItIs]
  );

  const [cmnRangeStates, setCmnRangeStates] = useState(initialRangeStates);

  const [allTrainers, setAllTrainers] = useState([]);
  const [allReceptionists, setAllReceptionists] = useState([]);
  const [allPlans, setAllPlans] = useState([]);
  const iniDropdownData = {
    allLandingPages: [],
  };
  const [allDropdownData, setAllDropdownData] = useState(iniDropdownData);
  const iniValues = {
    status: "active",
    limit: 10,
    page: 1,
    search: "",
  };
  const [fetchValues, setFetchValues] = useState(iniValues);
  const [totalPages, setTotalPages] = useState(1);

  const sendableGymId =
    prevGymId && prevGymId !== undefined && prevGymId !== "undefined"
      ? prevGymId
      : filters?.selectedGym?.value
      ? filters?.selectedGym?.value
      : "";

  let canShowCardBlock = true;
  let isOnlySearch = from === "only-search";

  if (
    from === "pt-flow-mem-table" ||
    from === "active_pt_with_expired_subscription" ||
    from === "dashboard-cards" ||
    from === "biomax-members" ||
    from === "cto-stats" ||
    from === "daily-target-matrics" ||
    onlySearch ||
    from === "trainer-checkedin-notcheckedin" ||
    from === "workout-packages"
  ) {
    canShowCardBlock = false;
  } else {
    canShowCardBlock =
      from === "payment-link"
        ? allPaymentOnlineData || allPaymentCashData
          ? true
          : false
        : true;
  }

  function getWorkoutCategory(filters) {
    dispatch(
      fetchWorkoutCategoriesData({
        filters: filters,
        token: decryptedText?.token,
      })
    );
  }

  function getWorkoutWorkoutSuitableFor() {
    const filters = {
      status: "active",
    };

    dispatch(
      fetchWorkoutExperiencesData({
        filters: filters,
        token: decryptedText?.token,
      })
    );
  }

  function getCentralisedPlans(fetchValues) {
    dispatch(
      fetchCentralisedPlansData({
        filters: fetchValues,
        token: decryptedText?.token,
      })
    );
  }

  function getIncentiveSlabs() {
    const filters = {
      status: "active",
      page: 1,
      limit: 3000,
    };

    dispatch(
      fetchIncentivesSlabsData({
        filters: filters,
        token: decryptedText?.token,
      })
    );
  }

  function getLeadSources(fetchValues) {
    dispatch(
      fetchLeadSourceData({
        filters: fetchValues,
        token: decryptedText?.token,
      })
    );
  }

  function getLandingPages() {
    const sendableFilters = {
      status: "active",
      page: 1,
      limit: 1000,
    };

    dispatch(
      fetchGymLandingPagesData({
        filters: sendableFilters,
        token: decryptedText?.token,
      })
    );
  }

  const handleDateRangeChangeMulti = (item, rangeKey) => {
    const startDate = item[rangeKey]?.startDate;
    const endDate = item[rangeKey]?.endDate;

    if (startDate && endDate) {
      setCmnRangeStates((prevRangeStates) => ({
        ...prevRangeStates,
        [rangeKey]: [item[rangeKey]],
      }));

      const formattedStartDate = format(startDate, "yyyy-MM-dd");
      const formattedEndDate = format(endDate, "yyyy-MM-dd");

      setFilters((prevFilters) => ({
        ...prevFilters,
        [`${rangeKey}From`]: formattedStartDate,
        [`${rangeKey}To`]: formattedEndDate,
      }));
    }
  };

  const clearDateRangerMulti = (rangeKey) => {
    setCmnRangeStates({
      ...cmnRangeStates,
      [rangeKey]: initialRangeStates[rangeKey],
    });

    setFilters((prevs) => ({
      ...prevs,
      [`${rangeKey}From`]: "",
      [`${rangeKey}To`]: "",
    }));
  };
  // ********-------------
  const handleSearchChange = (inputValue) => {
    setFetchValues((prev) => ({
      ...prev,
      page: 1,
      search: inputValue,
    }));
  };

  const fetchMoreData = () => {
    if (fetchValues.page + 1 <= totalPages) {
      setFetchValues((prev) => ({
        ...prev,
        page: prev.page + 1,
      }));
    }
  };

  const fetchPreviousData = () => {
    setFetchValues((prev) => ({
      ...prev,
      page: Math.max(prev.page - 1, 1),
    }));
  };
  // ------------------**********

  useEffect(() => {
    if (
      from !== "pt-flow-mem-table" &&
      from !== "active_pt_with_expired_subscription" &&
      from !== "dashboard-cards" &&
      from !== "biomax-members" &&
      from !== "cto-stats" &&
      from !== "daily-target-matrics" &&
      !onlySearch &&
      from !== "trainer-checkedin-notcheckedin" &&
      from !== "workout-packages"
    ) {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isCardBlockShow: true,
      }));
    }

    if (from === "subscriptions") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isSearchShow: true,
        isStatusShow: true,
        isCoupleplanFilterShow: true,
        isLeadSourceShow: true,
        isGenderShow: true,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
        // isTransferTypeShow: true,
        // isPauseStatusShow: true,
        isExperienceLevelShow: true,
        isPaymentLocationShow: true,
        isAllAccessPlanShow: true,
        isLandingPageKeywordShow: true,
      }));
    } else if (from === "dashboard-cards") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isCardBlockShow: true,
        isTwoGridSystem: true,
        isGridColsFiveSystem: isURE || isGlobal ? true : false,
        isOtherUsersShow:
          isGlobal ||
          isURE ||
          clickedCard === "expiring_this_month" ||
          clickedCard === "unpaid_members" ||
          clickedCard === "expiring_today"
            ? true
            : false,
        isButtonEnableShow: isURE ? true : false,
        isAddedNotAddedToLeadFilterShow: isURE ? true : false,
        isSearchShow: isGlobal || isTop ? false : true,
        isReloadBtnShow: isReload ? true : false,
        isToggleFilterShow: true,
      }));
    } else if (from === "sales-table") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isDateRangerShow: true,
        isTwoGridSystem: clickedCard === "checkins" || isSegment ? true : false,
        isGridColsFiveSystem: isSegment ? true : false,
        isLastCheckedInShow:
          clickedCard === "expiring_this_month" ||
          clickedCard === "unpaid_members"
            ? true
            : false,
        isLeastCheckinInBetweenShow:
          clickedCard === "expiring_this_month" ||
          clickedCard === "unpaid_members"
            ? true
            : false,
        isExpiringInDaysShow:
          clickedCard === "expiring_this_month" ? true : false,
        isExpiredDaysAgoShow: clickedCard === "unpaid_members" ? true : false,
        isExportBtnShow:
          (clickedCard === "expiring_this_month" ||
            clickedCard === "unpaid_members" ||
            clickedCard === "expiring_today") &&
          onClickExportBtn
            ? true
            : false,
        isOtherUsersShow: otherUserLabel ? true : false,
        isRecuNonRecuShow: clickedCard !== "checkins" ? true : false,
        isButtonEnableShow:
          clickedCard === "expiring_today" ||
          clickedCard === "expiring_this_month" ||
          clickedCard === "unpaid_members"
            ? true
            : false,
        isAddedNotAddedToLeadFilterShow:
          clickedCard === "expiring_today" ||
          clickedCard === "expiring_this_month" ||
          clickedCard === "unpaid_members"
            ? true
            : false,
        isPaymentSlotTimeFilterShow: clickedCard === "today" ? true : false,
        isSearchShow: onClickSearch ? true : false,
        isBroadcastBtnShow: onClickBroadcastBtn ? true : false,
        isPaymentSourceShow: clickedCard === "today" ? true : false,
        isPreGymSalesShow: clickedCard === "today" ? true : false,
        isPlanShow: clickedCard === "unpaid_members" ? true : false,
        isPriceRangeShow: clickedCard === "unpaid_members" ? true : false,
        isAddedByShow: isAdmin ? true : false,
        isReloadBtnShow: isReload ? true : false,
      }));
    } else if (from === "payment-link") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isDateRangerShow: true,
        isPaymentSourceShow: true,
        isCreatorShow: true,
        isSearchShow: true,
        isReloadBtnShow: isReload ? true : false,
      }));
    } else if (from === "partial-payments") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isDateRangerShow: true,
        isSearchShow: true,
      }));
    } else if (from === "partial-payment-link") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isDateRangerShow: true,
        isGridColsFiveSystem: true,
        isTwoGridSystem: true,
        isSearchShow: true,
        isPlanShow:
          filters?.selectedSubsType?.value === "regular" ? true : false,
      }));
    } else if (from === "leave-management-admin") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isDateRangerShow: true,
        isOtherUsersShow: isAdmin || isClusterManager ? true : false,
      }));
    } else if (from === "biomax-members") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isCardBlockShow: true,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
        isLastCheckedInShow: true,
        isLeastCheckinInBetweenShow: true,
        isTrainerLastCheckinTimeShow: true,

        isPTPlanStatusShow: true,
        isRegularSubsStatusShow: true,
        isMultiDateRangerShow: true,
        isBiomaxAppRegisterShow: true,
        isBiomaxRegisterStatusShow: true,
        isSearchShow: onClickSearch ? true : false,
        isTMEStatusShow: true,
        isTrainerShow: !isTrainer ? true : false,

        isBroadcastBtnShow: onClickBroadcastBtn ? true : false,
      }));
    } else if (from === "pt-incentives") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isMonthFilterShow: true,
        isYearFilterShow: true,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
        isTrainerShow: !isTrainer ? true : false,
        isIncentiveSlabShow: true,
      }));
    } else if (from === "daily-target") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isMonthFilterShow: true,
        isTwoGridSystem: !targetStats ? true : false,
        isGridColsFiveSystem: !targetStats ? true : false,
        // isOtherUsersShow: isAdmin ? true : false,
        isDailyTargetPlanTypesShow: true,
        isAddedByShow: isAdmin ? true : false,
        isReloadBtnShow: isReload ? true : false,
      }));
    } else if (from === "pt-trainer-performance") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isMonthFilterShow: true,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
        isTrainerShow: !isTrainer ? true : false,
      }));
    } else if (from === "ure-stat-detail") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isDateRangerShow: true,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
        isRenewalFromDayShow: clickedCard === "renewals_today" ? true : false,
        isRenewalFromMonthShow:
          clickedCard === "renewals_this_month" ? true : false,
        isOtherUsersShow: true,
        isRecuNonRecuShow: true,
        isButtonEnableShow: true,
        isAddedNotAddedToLeadFilterShow: true,
        isSearchShow: true,
      }));
    } else if (from === "live-monitoring") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isDateRangerShow: true,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTwoGridSystem: true,
      }));
    } else if (from === "pt-revenue") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isDateRangerShow: true,
        isTwoGridSystem: true,
        isTrainerShow: !isTrainer ? true : false,
        isSearchShow: true,
      }));
    } else if (from === "active_pt_with_expired_subscription") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isDateRangerShow: true,
        isCardBlockShow: true,
        isTwoGridSystem: true,
        isTrainerShow: !isTrainer ? true : false,
        isRegularSubsStatusShow: true,
        isSearchShow: true,
      }));
    } else if (from === "pt-flow") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isSearchShow: clickedCard !== "performance_evaluation" ? true : false,
        isTrainerShow: !isTrainer ? true : false,
        isPTPlanStatusShow:
          clickedCard !== "performance_evaluation" &&
          clickedCard !== "gt-pt-trainers" &&
          clickedCard !== "total_sales_today"
            ? true
            : false,
        isRegularSubsStatusShow:
          clickedCard !== "performance_evaluation" &&
          clickedCard !== "gt-pt-trainers" &&
          clickedCard !== "total_sales_today"
            ? true
            : false,
        isSignleDateShow: false,
        isSlotTimeFilterShow: clickedCard === "pt-session" ? true : false,
        isMonthFilterShow:
          clickedCard === "gt-pt-trainers" ||
          clickedCard === "performance_evaluation"
            ? true
            : false,
        isYearFilterShow:
          clickedCard === "gt-pt-trainers" ||
          clickedCard === "performance_evaluation"
            ? true
            : false,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
        isMultiDateRangerShow:
          clickedCard === "pt-revenue" ||
          clickedCard === "taee" ||
          clickedCard === "total_trial_subscription"
            ? true
            : false,
        isToggleFilterShow: clickedCardAsItIs === "expired" ? true : false,
        isConvertedStatusShow:
          clickedCardAsItIs === "total_trial_subscription" ? true : false,
        isExportBtnShow:
          (clickedCard === "taee" ||
            clickedCard === "total_trial_subscription") &&
          onClickExportBtn
            ? true
            : false,
        isExpiredDaysAgoShow: clickedCardAsItIs === "expired" ? true : false,
        isPTRevenueViewTypeShow:
          clickedCard === "total_sales_today" ? true : false,
      }));
    } else if (from === "pt-flow-mem-table") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isCardBlockShow: true,
        isRegularSubsStatusShow: true,
        isSearchShow: true,
      }));
    } else if (from === "daily-target-matrics") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isDateRangerShow: true,
        isCardBlockShow: true,
        isGymShow: isAdmin || isManagerRole ? true : false,
      }));
    } else if (from === "assigned-members") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isDateRangerShow: onlyDateRanger || isDateRanger ? true : false,
        isMonthFilterShow: !(
          clickedCard === "members_checkin_under_trainer_shift" ||
          clickedCard === "assigned_members" ||
          clickedCard === "not_assigned_members" ||
          clickedCard === "biomax_registered" ||
          clickedCard === "biomax_not_registered"
        )
          ? true
          : false,
        isTwoGridSystem: true,
        isSearchShow: true,
        isGridColsFiveSystem: !(
          clickedCard === "members_checkin_under_trainer_shift" ||
          clickedCard === "assigned_members" ||
          clickedCard === "not_assigned_members" ||
          clickedCard === "biomax_registered" ||
          clickedCard === "biomax_not_registered"
        )
          ? true
          : false,
      }));
    } else if (from === "cto-stats") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: true,
        isMonthFilterShow: true,
        isYearFilterShow: true,
        isCardBlockShow: true,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
      }));
    } else if (from === "trainer-checkedin-notcheckedin") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isCardBlockShow: true,
      }));
    } else if (from === "cupon-request") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isDateRangerShow: true,
        isPlanShow: filters.selectedGym?.value ? true : false,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
        isSearchShow: true,
      }));
    } else if (from === "gym-plans") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isPlanShow: true,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
        // isTrainerShow: !isTrainer ? true : false,
      }));
    } else if (from === "cart-history") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isDateRangerShow: true,
        isPlanDurationShow: true,
        isReceptionistShow: !isReceptionist ? true : false,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
        isSearchShow: true,
      }));
    } else if (from === "pt-trial") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isReceptionistShow: !isTrainer ? true : false,
        isTrainerShow: !isTrainer ? true : false,
        isSearchShow: true,
      }));
    } else if (from === "trainer-member") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isTwoGridSystem: true,
        isTrainerShow: !isTrainer ? true : false,
        isLastCheckedInShow: true,
        // isSearchShow: true,
        isGridColsFiveSystem: true,
      }));
    } else if (from === "workout-packages") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isTwoGridSystem: true,
        isGridColsFiveSystem: true,
        isSearchShow: true,
      }));
    } else if (from === "trainer-checkedin-notcheckedin") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isOtherUsersShow: isAdmin ? true : false,
      }));
    } else if (from === "pt-sale-stat") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isGymShow: isAdmin || isManagerRole ? true : false,
        isTrainerShow: !isTrainer ? true : false,
        isDateRangerShow: true,
        isTwoGridSystem: !targetStats ? true : false,
        isGridColsFiveSystem: !targetStats ? true : false,
        isSearchShow: true,
      }));
    } else if (from === "automation-keywords") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: true,
      }));
    } else if (from === "only-search") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isSearchShow: true,
      }));
    } else if (from === "diet-meals") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isStatusShow: true,
        isPopularShow: true,
      }));
    } else if (from === "workout-packages") {
      setAllowedFilters((prevs) => ({
        ...prevs,
        isStatusShow: true,
      }));
    }
  }, [filters]);

  useEffect(() => {
    if (from === "workout-packages") {
      getWorkoutCategory(fetchValues);
    }
  }, [fetchValues]);

  useEffect(() => {
    if (from === "cupon-request" && filters.selectedGym) {
      fetchValues.gym_id = filters.selectedGym?.value || "";
      getCentralisedPlans(fetchValues);
    }
  }, [fetchValues, filters.selectedGym]);

  useEffect(() => {
    if (from === "workout-packages") {
      getWorkoutWorkoutSuitableFor();
    }
  }, []);

  useEffect(() => {
    if (allowedFilters.isGymShow) {
      dispatch(
        fetchGymData(
          decryptedText?.token,
          1,
          100,
          "",
          "all",
          isClusterManager
            ? `&cluster_manager_id=${
                decryptedText?.user_id || decryptedText?.uid
              }`
            : ""
        )
      );
    }
  }, [allowedFilters.isGymShow]);

  useEffect(() => {
    const gymParam = filters.selectedGym?.value
      ? `&gym_id=${filters.selectedGym.value}`
      : !isAdmin && (decryptedText?.gym_id || decryptedText?.user_id)
      ? `&gym_id=${decryptedText?.gym_id || decryptedText?.user_id}`
      : "";

    if (allowedFilters.isCreatorShow) {
      dispatch(fetchAllAssigneeData(decryptedText?.token, gymParam));
    }
  }, [filters.selectedGym, allowedFilters.isCreatorShow]);

  useEffect(() => {
    if (allowedFilters.isOtherUsersShow || allowedFilters.isAddedByShow) {
      const gymQP = sendableGymId ? `gym_id=${sendableGymId}` : "";

      const filtertypeQP =
        from === "daily-target" || from === "sales-table"
          ? "user_types=cluster_manager"
          : approvalManagerFor
          ? `user_types=${
              approvalManagerFor === "all"
                ? "trainer,receptionist,fitness_manager"
                : approvalManagerFor
            }`
          : from !== "leave-management-admin" &&
            from !== "trainer-checkedin-notcheckedin"
          ? `user_types=admin,receptionist`
          : "";

      const finalQP = `${gymQP}&${filtertypeQP}`;
      dispatch(
        fetchInHouseUsersData({
          token: decryptedText?.token,
          qps: finalQP,
          pageNo: 1,
          limit: 100,
        })
      );
    }
  }, [
    sendableGymId,
    allowedFilters.isOtherUsersShow,
    approvalManagerFor,
    allowedFilters.isAddedByShow,
  ]);

  useEffect(() => {
    if (allowedFilters.isTrainerShow) {
      dispatch(
        fetchAllTrainersByExpLvlData({
          queryParameters:
            sendableGymId || decryptedText?.gym_id
              ? `&gym_id=${
                  sendableGymId || decryptedText?.gym_id
                }&status=active`
              : "&status=active",
          token: decryptedText?.token,
        })
      );
    }
  }, [allowedFilters.isTrainerShow, sendableGymId]);

  useEffect(() => {
    if (allowedFilters.isReceptionistShow) {
      dispatch(
        fetchUserDetailsByMobileData({
          userMobile: null,
          token: decryptedText?.token,
          qps: `account_type=receptionist${
            sendableGymId ? "&gym_id=" + sendableGymId : ""
          }`,
        })
      );
    }
  }, [allowedFilters.isReceptionistShow, sendableGymId]);

  useEffect(() => {
    if (filters?.selectedSubsType?.value === "regular") {
      dispatch(
        fetchRegularPlansData({
          token: decryptedText?.token,
          qps: `${sendableGymId ? "&gym_id=" + sendableGymId : ""}`,
          pageNo: 1,
          limit: 1000,
        })
      );
    } else if (filters?.selectedSubsType?.value === "addon") {
      dispatch(
        fetchAddonsData({
          token: decryptedText?.token,
          qps: `${sendableGymId ? "&gym_id=" + sendableGymId : ""}`,
          pageNo: 1,
          limit: 1000,
        })
      );
    }
  }, [filters?.selectedSubsType?.value, sendableGymId]);

  useEffect(() => {
    if (trainerIdToGetShifts) {
      const filter = {
        trainer_id: trainerIdToGetShifts,
      };

      dispatch(
        fetchTrainerShiftsData({
          filters: filter,
          token: decryptedText?.token,
        })
      );
    }
  }, [trainerIdToGetShifts]);

  useEffect(() => {
    if (allowedFilters.isIncentiveSlabShow) {
      getIncentiveSlabs();
    }
  }, [allowedFilters.isIncentiveSlabShow]);

  useEffect(() => {
    if (allowedFilters.isLeadSourceShow) {
      const filters = {
        limit: 2000,
        page: 1,
        is_rawlead: 0,
      };

      getLeadSources(filters);
    }
  }, [allowedFilters.isLeadSourceShow]);

  useEffect(() => {
    if (allowedFilters.isLandingPageKeywordShow) {
      getLandingPages();
    }
  }, [allowedFilters.isLandingPageKeywordShow]);

  useEffect(() => {
    if (
      allTrainerByExpLvlData?.status &&
      allTrainerByExpLvlData?.data?.length > 0
    ) {
      const trainers = allTrainerByExpLvlData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainers(trainers);
    } else {
      setAllTrainers([]);
    }
  }, [allTrainerByExpLvlData]);

  useEffect(() => {
    if (userDetailsByMobile?.status && userDetailsByMobile?.data?.length > 0) {
      const receptionists = userDetailsByMobile.data?.map((item) => ({
        value: item.uid,
        label: item.name,
      }));
      setAllReceptionists(receptionists);
    } else if (userDetailsByMobile?.status === false) {
      setAllReceptionists([]);
    }
  }, [userDetailsByMobile]);

  useEffect(() => {
    if (
      !gymLandingPagesLoading &&
      !gymLandingPagesError &&
      gymLandingPages?.status &&
      gymLandingPages?.data
    ) {
      const allData = gymLandingPages.data;

      const dropdownData = allData?.map((item) => ({
        value: item?.keyword || "",
        label: item?.keyword || "",
      }));

      setAllDropdownData((prevs) => ({
        ...prevs,
        allLandingPages: dropdownData,
      }));
    } else {
      setAllDropdownData((prevs) => ({
        ...prevs,
        allLandingPages: [],
      }));
    }
  }, [gymLandingPages, gymLandingPagesLoading, gymLandingPagesError]);

  useEffect(() => {
    if (
      (from === "subscriptions" ||
        (from === "sales-table" && canPlanFilters) ||
        from === "payment-link" ||
        from === "partial-payment-link") &&
      !filters?.selectedSubsType?.value
    ) {
      setFilters((prevs) => ({
        ...prevs,
        selectedPlan: "",
      }));
    }
  }, [filters?.selectedSubsType]);

  useEffect(() => {
    if (from === "workout-packages") {
      if (workoutCategoriesData?.pagination?.length > 0) {
        setTotalPages(workoutCategoriesData?.pagination?.[0]?.pagination || 1);
      } else {
        setTotalPages(1);
      }
    }
  }, [workoutCategoriesData]);

  useEffect(() => {
    if (centralisedPlans?.dropdown?.length > 0) {
      setTotalPages(centralisedPlans?.pagination?.[0]?.pagination || 1);
      setAllPlans(centralisedPlans.dropdown);
    }
  }, [centralisedPlans]);

  return (
    <>
      {/* ${MCUTSDate ? "MCUTSDate" : ""}
          ${DTMDate ? "DTMDate" : ""} 
          ${isBiomaxDate ? "isBiomaxDate" : ""} 
          ${isActiveDate ? "isActiveDate" : ""} 
          ${apesDate ? "apesDate" : ""}
          ${isLMAdminDate ? "isLMAdminDate" : null} */}

      {!isOnlySearch && !onlySearch && (
        <div
          className={`cmnFilterStructureContainer 
          ${clickedCard === "checkins" ? "checkinsDate" : ""}
          ${
            from === "payment-link"
              ? allPaymentOnlineData || allPaymentCashData
                ? "paymentLinkFilterContainer"
                : "grid-1"
              : isNotAdmin
              ? "ind-leave"
              : from === "partial-payments" || from === "leave-management-admin"
              ? "pmFiltersContainer"
              : from === "diet-meals"
              ? "mealsFiltersContainer"
              : from === "pt-flow-mem-table"
              ? "ptFlowMemTbFiltersContainer"
              : from === "sales-table" &&
                clickedCard !== "checkins" &&
                !isSegment
              ? "salesTableFiltersContainer"
              : from === "subscriptions"
              ? "daily-target-home subscriptions"
              : allowedFilters.isTwoGridSystem
              ? "trainerMemberFiltersContainer grid-2"
              : from === "daily-target" && targetStats
              ? "daily-target-home"
              : from === "automation-keywords"
              ? "grid-1"
              : ""
          }`}
          style={{ marginTop: from === "automation-keywords" ? "" : "1rem" }}
        >
          {canShowCardBlock && !isSegment ? (
            <CmnFilterStrctureCardBlock
              from={from}
              targetStats={targetStats}
              partialStatsData={partialStatsData}
              allPaymentOnlineData={allPaymentOnlineData}
              allPaymentCashData={allPaymentCashData}
              allSubsTbData={allSubsTbData}
              allSubsPlanStatsData={allSubsPlanStatsData}
              allMaleFemaleBurification={allMaleFemaleBurification}
              partialPaymentInfo={partialPaymentInfo}
              ptCardData={ptCardData}
              salesTodayValues={salesTodayValues}
              filterType={filterType}
              totalSaleData={totalSaleData}
              staffLeaveStats={staffLeaveStats}
              staffLeavesYearStats={staffLeavesYearStats}
              staffLeavesStats={staffLeavesStats}
              totalMemberData={totalMemberData}
              clickedCard={clickedCard}
              isLoading={isLoading}
            />
          ) : null}

          {!isAdmin && from === "dashboard-cards" ? null : (
            <div
              className={`filterblock ${
                from === "automation-keywords"
                  ? "filter-block-filters"
                  : "gridSpanTwo"
              }`}
            >
              {openDateRanger && (
                <DateRanger
                  handleDateRangeChange={handleDateRangeChange}
                  rangeState={rangeState}
                  onClose={() => setOpenDateRanger(false)}
                  onClear={clearDateRanger}
                  isDisableFutureDates={isDisableFutureDates}
                />
              )}

              <div className="filterHeadingNBtn">
                <h5 className="filterHeading">
                  {isSegment ? "Create Segment" : "All Filters"}
                </h5>

                {from === "assigned-members" && isChekboxFilters ? (
                  <div className="flexEnd">
                    <div className="checkbox-btns">
                      <Form.Check
                        type="switch"
                        name="isAll"
                        label="All"
                        checked={filters.isAll}
                        onChange={(event) =>
                          setFilters({
                            ...filters,
                            isAll: event.target.checked,
                          })
                        }
                      />
                      <Form.Check
                        type="switch"
                        name="isOnlyCheckedIn"
                        label="Only Checked In"
                        checked={filters.isOnlyCheckedIn}
                        onChange={(event) =>
                          setFilters({
                            ...filters,
                            isOnlyCheckedIn: event.target.checked,
                          })
                        }
                      />
                      <Form.Check
                        type="switch"
                        name="isOnlyNotCheckedIn"
                        label="Only Not Checked In"
                        checked={filters.isOnlyNotCheckedIn}
                        onChange={(event) =>
                          setFilters({
                            ...filters,
                            isOnlyNotCheckedIn: event.target.checked,
                          })
                        }
                      />
                    </div>

                    <Button
                      type="button"
                      variant="outline-danger"
                      onClick={onClickReset}
                    >
                      Reset Filter
                    </Button>
                  </div>
                ) : (
                  <div className="filterHeadingBtnBlock lastOne">
                    {allowedFilters.isReloadBtnShow ? (
                      <button
                        variant="dark"
                        type="button"
                        onClick={isReload}
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          border: "none",
                          backgroundColor: "#000",
                          cursor: "pointer",
                          color: "#fff",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-arrow-clockwise"
                          viewBox="0 0 16 16"
                          style={{
                            color: "#fff",
                            fill: "#fff",
                          }}
                        >
                          <path
                            fillRule="evenodd"
                            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                          />
                          <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                        </svg>
                      </button>
                    ) : null}

                    {allowedFilters.isToggleFilterShow ? (
                      <div className="checkbox-btns">
                        <Form.Check
                          type="switch"
                          name="isToggledValue"
                          label={
                            from === "dashboard-cards"
                              ? "Switch To Beta Mode"
                              : "Remove Duplicacy"
                          }
                          checked={filters.isToggledValue}
                          onChange={(event) =>
                            setFilters({
                              ...filters,
                              isToggledValue: event.target.checked,
                            })
                          }
                        />
                      </div>
                    ) : null}

                    {allowedFilters.isBroadcastBtnShow ? (
                      <RedButton
                        btnName={"Broadcast Campaign"}
                        onClickBtn={onClickBroadcastBtn}
                        isDark={true}
                      />
                    ) : null}

                    {allowedFilters.isExportBtnShow ? (
                      <RedButton
                        btnName={"Export Data"}
                        onClickBtn={onClickExportBtn}
                      />
                    ) : null}

                    <Button
                      type="button"
                      variant="outline-danger"
                      onClick={onClickReset}
                    >
                      Reset Filter
                    </Button>
                  </div>
                )}
              </div>

              <div
                className={`filtersDropdown mb20 ${
                  allowedFilters.isGridColsFiveSystem ? "grid-5" : ""
                }`}
              >
                {allowedFilters.isMultiDateRangerShow && (
                  <>
                    {Object.keys(cmnRangeStates)?.map((rangeKey) => (
                      <React.Fragment key={rangeKey}>
                        {activeCmnDateRanges[rangeKey] && (
                          <DateRanger
                            handleDateRangeChange={(item) =>
                              handleDateRangeChangeMulti(item, rangeKey)
                            }
                            rangeState={cmnRangeStates[rangeKey]}
                            onClose={() =>
                              setCmnActiveDateRanges(
                                (prevActiveDateRanges) => ({
                                  ...prevActiveDateRanges,
                                  [rangeKey]: false,
                                })
                              )
                            }
                            onClear={() => clearDateRangerMulti(rangeKey)}
                            isDisabled={isLoading}
                          />
                        )}

                        <div
                          className={`commonWrapper dropdownCommonWrapper darerangerCommonWrapper ${
                            (filters[`${rangeKey}From`] ||
                              filters[`${rangeKey}To`]) &&
                            "redBorderRedText"
                          }`}
                        >
                          {activeCmnDateRanges[rangeKey] ? (
                            <div className="closeAndClearDateRangerButtons">
                              <button
                                type="button"
                                className="closeClearBtn notmalButtonStyles noStyle closeRangerBtn"
                                onClick={() =>
                                  setCmnActiveDateRanges(
                                    (prevActiveDateRanges) => ({
                                      ...prevActiveDateRanges,
                                      [rangeKey]: false,
                                    })
                                  )
                                }
                              >
                                Close
                              </button>
                              <button
                                type="button"
                                className="closeClearBtn notmalButtonStyles noStyle clearRangerBtn"
                                onClick={() => clearDateRangerMulti(rangeKey)}
                              >
                                Clear
                              </button>
                            </div>
                          ) : (
                            <div className="flex-between">
                              <button
                                type="button"
                                className="notmalButtonStyles noStyle long_one"
                                onClick={() => {
                                  setCmnActiveDateRanges(
                                    (prevActiveDateRanges) => ({
                                      ...Object.keys(
                                        prevActiveDateRanges
                                      ).reduce((acc, key) => {
                                        acc[key] =
                                          key === rangeKey
                                            ? !prevActiveDateRanges[key]
                                            : false;
                                        return acc;
                                      }, {}),
                                    })
                                  );
                                }}
                                disabled={isLoading}
                              >
                                {filters[`${rangeKey}From`] ||
                                filters[`${rangeKey}To`]
                                  ? `${moment(filters[`${rangeKey}From`])
                                      .tz("Asia/Kolkata")
                                      .format("DD-MM-YYYY")} - ${moment(
                                      filters[`${rangeKey}To`]
                                    )
                                      .tz("Asia/Kolkata")
                                      .format("DD-MM-YYYY")}`
                                  : getDateRangerLable(rangeKey, from)}
                              </button>
                              <button
                                type="button"
                                className="notmalButtonStyles noStyle short_one"
                                onClick={() => {
                                  clearDateRangerMulti(rangeKey);
                                }}
                              >
                                <span className="icon calender">
                                  {filters[`${rangeKey}From`] ||
                                  filters[`${rangeKey}To`] ? (
                                    <RedCrossIcon />
                                  ) : (
                                    <DatePickerIcon
                                      color={
                                        filters[`${rangeKey}From`] ||
                                        filters[`${rangeKey}To`]
                                          ? "green"
                                          : "#898989"
                                      }
                                    />
                                  )}
                                </span>
                              </button>
                            </div>
                          )}
                        </div>
                      </React.Fragment>
                    ))}
                  </>
                )}

                {from === "subscriptions" && (
                  <>
                    {Object.keys(rangeStates).map((rangeKey, index) => (
                      <div
                        key={rangeKey}
                        className={`dateRangerOuterontainer multiDateRangerCommonFilters ${rangeKey}`}
                      >
                        {activeDateRanges[rangeKey] && (
                          <DateRanger
                            handleDateRangeChange={(item) =>
                              handleDateRangeChange(item, rangeKey)
                            }
                            rangeState={rangeStates[rangeKey]}
                            onClose={() =>
                              setActiveDateRanges({
                                ...activeDateRanges,
                                [rangeKey]: false,
                              })
                            }
                            onClear={() => {
                              setActiveDateRanges({
                                ...activeDateRanges,
                                [rangeKey]: false,
                              });
                              clearDateRanger(rangeKey);
                            }}
                          />
                        )}

                        <span className="label date-ranger-label">
                          {rangeKey === "subsStart"
                            ? "Start in Between"
                            : rangeKey === "subsCreate"
                            ? "Created in Between"
                            : rangeKey === "subsExpiring"
                            ? "Expiring in Between"
                            : rangeKey === "subsExpired"
                            ? "Expired in Between"
                            : "Select Dates"}

                          {(activeDateRanges[rangeKey] ||
                            filters[`${rangeKey}From`] ||
                            filters[`${rangeKey}To`]) && (
                            <div className="closeAndClearDateRangerButtons">
                              <button
                                type="button"
                                className="notmalButtonStyles noStyle closeRangerBtn"
                                onClick={() => {
                                  setActiveDateRanges({
                                    ...activeDateRanges,
                                    [rangeKey]: false,
                                  });
                                }}
                              >
                                <WhiteBgCheckIcon />
                                close
                              </button>
                              <button
                                type="button"
                                className="notmalButtonStyles noStyle clearRangerBtn"
                                onClick={() => {
                                  setActiveDateRanges({
                                    ...activeDateRanges,
                                    [rangeKey]: false,
                                  });
                                  clearDateRanger(rangeKey);
                                }}
                              >
                                <WhiteBgXIcon />
                                Clear
                              </button>
                            </div>
                          )}
                        </span>

                        <div
                          className={`commonWrapper dropdownCommonWrapper darerangerCommonWrapper ${
                            (filters[`${rangeKey}From`] ||
                              filters[`${rangeKey}To`]) &&
                            "redBorderRedText"
                          } ${isLoading ? "disabled" : ""}`}
                        >
                          <button
                            type="button"
                            className="notmalButtonStyles noStyle"
                            disabled={isLoading}
                            onClick={() => {
                              setActiveDateRanges((prevActiveDateRanges) => ({
                                ...Object.keys(prevActiveDateRanges).reduce(
                                  (acc, key) => {
                                    acc[key] =
                                      key === rangeKey
                                        ? !prevActiveDateRanges[key]
                                        : false;
                                    return acc;
                                  },
                                  {}
                                ),
                              }));
                            }}
                          >
                            {filters[`${rangeKey}From`] ||
                            filters[`${rangeKey}To`]
                              ? `${moment(filters[`${rangeKey}From`])
                                  .tz("Asia/Kolkata")
                                  .format("DD-MM-YYYY")} TO ${moment(
                                  filters[`${rangeKey}To`]
                                )
                                  .tz("Asia/Kolkata")
                                  .format("DD-MM-YYYY")}`
                              : "Select Date"}
                          </button>
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {allowedFilters.isDateRangerShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper darerangerCommonWrapper ${
                      filters?.selectedStartDate || filters?.selectedEndDate
                        ? "redBorderRedText"
                        : ""
                    }  ${isLoading ? "disabled" : ""} `}
                  >
                    {openDateRanger ? (
                      <div className="closeAndClearDateRangerButtons">
                        <button
                          type="button"
                          className="closeClearBtn notmalButtonStyles noStyle closeRangerBtn"
                          onClick={() => setOpenDateRanger(false)}
                          style={{ textAlign: "center" }}
                          disabled={isDisabledDate}
                        >
                          <WhiteBgCheckIcon />
                          Close
                        </button>
                        <button
                          type="button"
                          className="closeClearBtn notmalButtonStyles noStyle clearRangerBtn"
                          onClick={clearDateRanger}
                          style={{ textAlign: "center" }}
                          disabled={isDisabledDate}
                        >
                          <WhiteBgXIcon />
                          Clear
                        </button>
                      </div>
                    ) : filters?.selectedStartDate ||
                      filters?.selectedEndDate ? (
                      <div
                        className="flex-between"
                        style={{ columnGap: "10px" }}
                      >
                        <button
                          type="button"
                          className="notmalButtonStyles noStyle long_one"
                          onClick={() => setOpenDateRanger(true)}
                          style={{ fontSize: "12px" }}
                          disabled={isDisabledDate}
                        >
                          <span className="dates">
                            {moment(filters?.selectedStartDate)
                              .tz("Asia/Kolkata")
                              .format("DD-MM-YYYY")}
                          </span>
                          <small>TO</small>
                          <span className="dates">
                            {moment(filters?.selectedEndDate)
                              .tz("Asia/Kolkata")
                              .format("DD-MM-YYYY")}
                          </span>
                        </button>

                        <button
                          type="button"
                          className="notmalButtonStyles noStyle short_one"
                          onClick={() => clearDateRanger()}
                          disabled={isDisabledDate}
                        >
                          <span className="icon calender">
                            <RedCrossIcon />
                          </span>
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        className="notmalButtonStyles noStyle"
                        disabled={isLoading || isDisabledDate}
                        onClick={() => setOpenDateRanger(true)}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "1rem",
                        }}
                      >
                        {from === "assigned-members" && !onlySearch
                          ? "Checkin Date Range"
                          : from === "partial-payment-link"
                          ? "Select Payment Schedule Date"
                          : from === "pt-flow"
                          ? "Date Added"
                          : from === "partial-payments"
                          ? "Date Added"
                          : "Date"}

                        <span className="icon calender">
                          <DatePickerIcon />
                        </span>
                      </button>
                    )}
                  </div>
                )}

                {allowedFilters.isGymShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" ? (
                      <span className="label">gym</span>
                    ) : null}

                    {isSegment ? (
                      <div
                        className={`commonWrapper dropdownCommonWrapper multiselect-filter ${
                          filters?.selectedGyms?.length > 0
                            ? "redBorderRedText"
                            : ""
                        }`}
                      >
                        <MultiSelect
                          options={gymData}
                          state={filters?.selectedGyms}
                          setState={(selectedValue) =>
                            setFilters({
                              ...filters,
                              selectedGyms: selectedValue,
                            })
                          }
                          name="Gym"
                        />
                      </div>
                    ) : (
                      <div
                        className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                          filters?.selectedGym?.value && "redBorderRedText"
                        }`}
                      >
                        <SelectDropdown
                          options={gymData}
                          selectedOption={filters?.selectedGym}
                          setSelectedOption={(selectedValue) =>
                            setFilters({
                              ...filters,
                              selectedGym: selectedValue,
                            })
                          }
                          name="Gym"
                          isDisable={isLoading}
                        />
                      </div>
                    )}
                  </div>
                )}

                {allowedFilters.isTrainerShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedTrainer?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={allTrainers}
                      selectedOption={filters?.selectedTrainer}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedTrainer: selectedValue,
                        })
                      }
                      name="Trainer"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isReceptionistShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedReceptionist?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdown
                      options={allReceptionists}
                      selectedOption={filters?.selectedReceptionist}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedReceptionist: selectedValue,
                        })
                      }
                      name="Sales Executive"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {from === "pt-trial" && (
                  <>
                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedHandoverStatus?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdown
                        options={handoverStatuses}
                        selectedOption={filters?.selectedHandoverStatus}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedHandoverStatus: selectedValue,
                          })
                        }
                        name="Handover Status"
                        isDisable={isLoading}
                      />
                    </div>

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedPTTrialStatus?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdown
                        options={ptTrialStatuses}
                        selectedOption={filters?.selectedPTTrialStatus}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedPTTrialStatus: selectedValue,
                          })
                        }
                        name="Trial Status"
                        isDisable={isLoading}
                      />
                    </div>
                  </>
                )}

                {(from === "payment-link" || from === "cupon-request") && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedStatus?.value && "redBorderRedText"
                    }`}
                  >
                    <SelectDropdownLabel
                      options={
                        from === "cupon-request"
                          ? paymentStatusCupon
                          : paymentStatus
                      }
                      selectedOption={filters?.selectedStatus}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedStatus: isStatusDisabled
                            ? isStatusDisabled
                            : selectedValue,
                        })
                      }
                      name={
                        from === "payment-link"
                          ? "Payment Status (Online)"
                          : "Payment Status"
                      }
                      isDisable={isLoading || isStatusDisabled}
                    />
                  </div>
                )}

                {from === "payment-link" && (
                  <>
                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedPaymentType?.value &&
                        "redBorderRedText"
                      }`}
                    >
                      <SelectDropdown
                        options={paymnetTypes}
                        selectedOption={filters?.selectedPaymentType}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedPaymentType: selectedValue,
                          })
                        }
                        name="Payment Type"
                        isDisable={isLoading}
                      />
                    </div>

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedApprovalStatus?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdown
                        options={approvalStatus}
                        selectedOption={filters?.selectedApprovalStatus}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedApprovalStatus: selectedValue,
                          })
                        }
                        name="Approval Status (Cash)"
                        isDisable={isLoading}
                      />
                    </div>
                  </>
                )}

                {allowedFilters.isCreatorShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedCreator?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={assigneeData}
                      selectedOption={filters?.selectedCreator}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedCreator: selectedValue,
                        })
                      }
                      name="Created By"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {(from === "subscriptions" ||
                  (from === "sales-table" && canPlanFilters) ||
                  from === "payment-link" ||
                  from === "partial-payment-link" ||
                  from === "cupon-request" ||
                  from === "gym-plans") && (
                  <>
                    {from === "sales-table" ||
                    from === "payment-link" ||
                    from === "partial-payment-link" ? (
                      <div
                        className={`commonWrapper dropdownCommonWrapper ${
                          filters?.selectedSubsType?.value
                            ? "redBorderRedText"
                            : ""
                        }`}
                      >
                        <SelectDropdown
                          options={
                            from === "payment-link"
                              ? subscriptionTypes1
                              : subscriptionTypes
                          }
                          selectedOption={filters?.selectedSubsType}
                          setSelectedOption={(selectedValue) =>
                            setFilters({
                              ...filters,
                              selectedSubsType: selectedValue,
                            })
                          }
                          name="Membership Type"
                          isDisable={isLoading}
                        />
                      </div>
                    ) : (
                      <>
                        {from !== "cupon-request" && from !== "gym-plans" && (
                          <div className="commonWrapperWithLabel">
                            <span className="label">Subscription Type</span>

                            <div
                              className={`commonWrapper dropdownCommonWrapper ${
                                filters?.selectedSubsType?.value
                                  ? "redBorderRedText"
                                  : ""
                              }`}
                            >
                              <SelectDropdownLabel
                                options={subscriptionTypes}
                                selectedOption={filters?.selectedSubsType}
                                setSelectedOption={(selectedValue) =>
                                  setFilters({
                                    ...filters,
                                    selectedSubsType: selectedValue,
                                  })
                                }
                                name="Type"
                                isDisable={isLoading}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}

                {allowedFilters.isPlanShow ? (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" ? (
                      <span className="label">Plan</span>
                    ) : null}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedPlan?.value ? "redBorderRedText" : ""
                      }`}
                    >
                      {/* {from === "cupon-request" &&
                        filters.selectedGym?.value && (
                          <SelectDropdownDynamic
                            options={allPlans}
                            selectedOption={filters?.selectedPlan}
                            setSelectedOption={(selectedValue) =>
                              setFilters({
                                ...filters,
                                selectedPlan: selectedValue,
                              })
                            }
                            name="Select Plan"
                            isDisable={isLoading}
                            onSearchChange={handleSearchChange}
                            fetchMoreData={fetchMoreData}
                            fetchPreviousData={fetchPreviousData}
                          />
                        )} */}

                      <SelectDropdown
                        options={
                          from === "cupon-request" && filters.selectedGym?.value
                            ? allPlans
                            : from === "subscriptions" || from === "gym-plans"
                            ? regularPlansDropdown
                            : regularPlanDurationsDropdwon
                        }
                        selectedOption={filters?.selectedPlan}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedPlan: selectedValue,
                          })
                        }
                        name="Plan"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                ) : null}

                {from === "subscriptions" && (
                  <div className="commonWrapperWithLabel">
                    <span className="label">Transaction Mode</span>

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedTrxType?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdownLabel
                        options={paymentModesSubs}
                        selectedOption={filters?.selectedTrxType}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedTrxType: selectedValue,
                          })
                        }
                        name="Select Transaction Mode"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isStatusShow && (
                  <div className="commonWrapperWithLabel">
                    {(from === "diet-meals" || from === "subscriptions") && (
                      <span className="label">Status</span>
                    )}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.isActive?.value ? "redBorderRedText" : ""
                      }`}
                    >
                      <SelectDropdown
                        options={
                          from === "subscriptions"
                            ? subscription_status
                            : activeInactiveStatus
                        }
                        selectedOption={filters?.isActive}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            isActive: selectedValue,
                          })
                        }
                        name="Status"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isPopularShow && (
                  <div className="commonWrapperWithLabel">
                    <span className="label">Popularity</span>

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.isPopular?.value ? "redBorderRedText" : ""
                      }`}
                    >
                      <SelectDropdown
                        options={subscriptionDays}
                        selectedOption={filters?.isPopular}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            isPopular: selectedValue,
                          })
                        }
                        name="Popolarty"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isRegularSubsStatusShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "pt-flow-mem-table" ? (
                      <span className="label">Regular Subscription Status</span>
                    ) : null}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.regularSubsStatus?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdownLabel
                        options={
                          from === "biomax-members"
                            ? susbscriptionStatusBRM
                            : susbscriptionStatus
                        }
                        selectedOption={filters?.regularSubsStatus}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            regularSubsStatus: selectedValue,
                          })
                        }
                        name="Regular Plan Status"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isPTPlanStatusShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selPTPlanStatus?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={pt_plan_status}
                      selectedOption={filters?.selPTPlanStatus}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selPTPlanStatus: selectedValue,
                        })
                      }
                      name="PT Plan Status"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {(from === "pt-flow-mem-table" || from === "pt-revenue") && (
                  <div className="commonWrapperWithLabel">
                    {from === "pt-flow-mem-table" ? (
                      <span className="label">PT Susbcription Status</span>
                    ) : null}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.ptSubsStatus?.value ? "redBorderRedText" : ""
                      }`}
                    >
                      <SelectDropdown
                        options={susbscriptionStatus}
                        selectedOption={filters?.ptSubsStatus}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            ptSubsStatus: selectedValue,
                          })
                        }
                        name="PT Susbcription Status"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isBiomaxRegisterStatusShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.isBiomaxRegister?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={biomaxStatus}
                      selectedOption={filters?.isBiomaxRegister}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          isBiomaxRegister: selectedValue,
                        })
                      }
                      name="Biomax Register Status"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {from === "sales-table" && clickedCard !== "checkins" && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedTrxMode?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={trxModes}
                      selectedOption={filters?.selectedTrxMode}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedTrxMode: selectedValue,
                        })
                      }
                      name="Payment Mode"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isDailyTargetPlanTypesShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selecteRPType?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={RPTypes}
                      selectedOption={filters?.selecteRPType}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selecteRPType: selectedValue,
                        })
                      }
                      name="Type"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isMonthFilterShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedMonth?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={months}
                      selectedOption={filters?.selectedMonth}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedMonth: selectedValue,
                        })
                      }
                      name="Month"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isYearFilterShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedYear?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={"pt-incentives" ? yearsIncludingNext : years}
                      selectedOption={filters?.selectedYear}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedYear: selectedValue,
                        })
                      }
                      name="Year"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isLastCheckedInShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.lastCheckedIn?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={daysAgo}
                      selectedOption={filters?.lastCheckedIn}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          lastCheckedIn: selectedValue,
                        })
                      }
                      name="Member Last Checked In"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isBiomaxAppRegisterShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selBiomaxAppRegister?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={biomaxAppRegisterStatus}
                      selectedOption={filters?.selBiomaxAppRegister}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selBiomaxAppRegister: selectedValue,
                        })
                      }
                      name="Biomax First Step (App Register)"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isLeastCheckinInBetweenShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper multiselect-filter ${
                      filters?.selLeastCheckinInBetween?.length > 0
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <MultiSelect
                      options={timeSlots}
                      state={filters?.selLeastCheckinInBetween}
                      setState={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selLeastCheckinInBetween: selectedValue,
                        })
                      }
                      name="Member Checkin Time"
                      preventKeyboardOpen={true}
                    />
                  </div>
                )}

                {allowedFilters.isTrainerLastCheckinTimeShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper multiselect-filter ${
                      filters?.selectedTrainerCheckinTime?.length > 0
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <MultiSelect
                      options={timeSlots}
                      state={filters?.selectedTrainerCheckinTime}
                      setState={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedTrainerCheckinTime: selectedValue,
                        })
                      }
                      name="Trainer Checkin Time"
                      preventKeyboardOpen={true}
                    />
                  </div>
                )}

                {allowedFilters.isExpiringInDaysShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selExpiringInDays?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdown
                      options={withinDays}
                      selectedOption={filters?.selExpiringInDays}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selExpiringInDays: selectedValue,
                        })
                      }
                      name="Expiring In"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isExpiredDaysAgoShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper multiselect-filter ${
                      filters?.selExpiredDaysAgo?.length > 0
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <MultiSelect
                      options={daysAgoUptoYear}
                      state={filters?.selExpiredDaysAgo}
                      setState={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selExpiredDaysAgo: selectedValue,
                        })
                      }
                      name="Expired Days Ago"
                      preventKeyboardOpen={false}
                      // isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isOtherUsersShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedOtherUsers?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdown
                      options={
                        from === "trainer-checkedin-notcheckedin" && isTrainers
                          ? inhouseUsers?.filter((value) =>
                              value?.label?.includes("trainer")
                            )
                          : from === "trainer-checkedin-notcheckedin" &&
                            isReceptionists
                          ? inhouseUsers?.filter((value) =>
                              value?.label?.includes("Sales Executive")
                            )
                          : inhouseUsers
                      }
                      selectedOption={filters?.selectedOtherUsers}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedOtherUsers: selectedValue,
                        })
                      }
                      name={`${
                        from === "leave-management-admin"
                          ? "Staff"
                          : otherUserLabel
                          ? otherUserLabel?.replace(/_/g, " ")
                          : from === "daily-target"
                          ? "Cluster Manager"
                          : "User"
                      }`}
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isAddedByShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selAddedby?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={inhouseUsers?.length > 0 ? inhouseUsers : []}
                      selectedOption={filters?.selAddedby}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selAddedby: selectedValue,
                        })
                      }
                      name={`${"Cluster Manager"}`}
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {from === "leave-management-admin" && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedLeaveStatus?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdown
                      options={leaveStatus}
                      selectedOption={filters?.selectedLeaveStatus}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedLeaveStatus: selectedValue,
                        })
                      }
                      name={"Leave Status"}
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {from === "live-monitoring" && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper timeranger ${
                      filters?.selectedStartTime && filters?.selectedEndTime
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <div className="time-slot">
                      <input
                        type="time"
                        className="input"
                        placeholder="Start Time"
                        value={filters?.selectedStartTime}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            selectedStartTime: e.target.value,
                          })
                        }
                      />
                    </div>
                    <span
                      className="mid-label"
                      style={{
                        fontWeight:
                          filters?.selectedStartTime && filters?.selectedEndTime
                            ? "bold"
                            : "500",
                        color:
                          filters?.selectedStartTime && filters?.selectedEndTime
                            ? "#328300"
                            : "#c0c0c0",
                      }}
                    >
                      time
                    </span>
                    <div className="time-slot">
                      <input
                        type="time"
                        className="input"
                        placeholder="End Time"
                        value={filters?.selectedEndTime}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            selectedEndTime: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                )}

                {isShiftDropdown ? (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedShift ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={
                        trainerShifts && trainerShifts?.length > 0
                          ? trainerShifts
                          : []
                      }
                      selectedOption={filters?.selectedShift}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedShift: selectedValue,
                        })
                      }
                      name="Trainer Shift"
                      isDisable={isLoading}
                    />
                  </div>
                ) : null}

                {isDisabledGym ? (
                  <div className={`commonWrapper dropdownCommonWrapper`}>
                    <SelectDropdown
                      options={
                        trainerShifts && trainerShifts?.length > 0
                          ? trainerShifts
                          : []
                      }
                      selectedOption={isDisabledGym}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedShift: selectedValue,
                        })
                      }
                      name="Trainer Shift"
                      isDisable={true}
                    />
                  </div>
                ) : null}

                {allowedFilters.isIncentiveSlabShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedSlab?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={
                        Array.isArray(ptIncentivesSlabs?.dropdown) &&
                        ptIncentivesSlabs?.dropdown.length > 0
                          ? ptIncentivesSlabs.dropdown
                          : []
                      }
                      selectedOption={filters?.selectedSlab}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedSlab: selectedValue,
                        })
                      }
                      name="Slab"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isRecuNonRecuShow ? (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selRecurringStatus ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={recurringStatus}
                      selectedOption={filters?.selRecurringStatus}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selRecurringStatus: selectedValue,
                        })
                      }
                      name="Recurring/Non-Recurring"
                      isDisable={isLoading}
                    />
                  </div>
                ) : null}

                {from === "workout-packages" && (
                  <>
                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selCategoryName?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdownDynamic
                        options={workoutCategoriesData?.dropdown || []}
                        selectedOption={filters?.selCategoryName}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selCategoryName: selectedValue,
                          })
                        }
                        name="category"
                        onSearchChange={handleSearchChange}
                        fetchMoreData={fetchMoreData}
                        fetchPreviousData={fetchPreviousData}
                        isDisable={isLoading}
                      />
                    </div>

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selPlanSuitableFor?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdown
                        options={workoutExperiences?.dropdown || []}
                        selectedOption={filters?.selPlanSuitableFor}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selPlanSuitableFor: selectedValue,
                          })
                        }
                        name="Plan Access"
                        isDisable={isLoading}
                      />
                    </div>
                  </>
                )}

                {allowedFilters.isPaymentSourceShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selPaymentSource?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={
                        clickedCard === "today"
                          ? payment_sources
                          : paymentSources
                      }
                      selectedOption={filters?.selPaymentSource}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selPaymentSource: selectedValue,
                        })
                      }
                      name="Payment Source"
                      preventKeyboardOpen={true}
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isPlanDurationShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedPlan?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={regularPlansDropdown}
                      selectedOption={filters?.selectedPlan}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedPlan: selectedValue,
                        })
                      }
                      name="Plan"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isRenewalFromDayShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selRenewalFromDay?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={renewalFromCurrent}
                      selectedOption={filters?.selRenewalFromDay}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selRenewalFromDay: selectedValue,
                        })
                      }
                      name="Same/Other Day View"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isRenewalFromMonthShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selRenewalFromMonth?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdown
                      options={renewalFromPast}
                      selectedOption={filters?.selRenewalFromMonth}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selRenewalFromMonth: selectedValue,
                        })
                      }
                      name="Same/Other Month View"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isButtonEnableShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selButtonEnabled?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={lead_btn_enable}
                      selectedOption={filters?.selButtonEnabled}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selButtonEnabled: selectedValue,
                        })
                      }
                      name="Add To LMS Button Status"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isAddedNotAddedToLeadFilterShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selAddNotAddToLead?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={added_not_added_to_lead}
                      selectedOption={filters?.selAddNotAddToLead}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selAddNotAddToLead: selectedValue,
                        })
                      }
                      name="Added/Not Added To Lead"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isPaymentSlotTimeFilterShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper multiselect-filter ${
                      filters?.selPaymentTimeSlot?.length > 0
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <MultiSelect
                      options={timeSlotsQuarter}
                      state={filters?.selPaymentTimeSlot}
                      setState={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selPaymentTimeSlot: selectedValue,
                        })
                      }
                      name="Payment Time"
                      preventKeyboardOpen={true}
                    />
                  </div>
                )}

                {allowedFilters.isSignleDateShow && (
                  <SingleDatePicker filters={filters} setFilters={setFilters} />
                )}

                {allowedFilters.isSlotTimeFilterShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedSlotTime?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={slot_times}
                      selectedOption={filters?.selectedSlotTime}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedSlotTime: selectedValue,
                        })
                      }
                      name="Slot Time"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isTMEStatusShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedTMEstatus?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={tmeStatus}
                      selectedOption={filters?.selectedTMEstatus}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedTMEstatus: selectedValue,
                        })
                      }
                      name="TME Status"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isConvertedStatusShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedConvertedStatus?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={conversion_status_boolean}
                      selectedOption={filters?.selectedConvertedStatus}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedConvertedStatus: selectedValue,
                        })
                      }
                      name="Conversion Status"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isPTRevenueViewTypeShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedPTRevenueViewType?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={pt_revenue_view_type}
                      selectedOption={filters?.selectedPTRevenueViewType}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedPTRevenueViewType: selectedValue,
                        })
                      }
                      name="Payment Type"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {allowedFilters.isCoupleplanFilterShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" && (
                      <span className="label">Link Type</span>
                    )}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedCouplePlan?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdown
                        options={couple_plan_filter}
                        selectedOption={filters?.selectedCouplePlan}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedCouplePlan: selectedValue,
                          })
                        }
                        name="Link Type"
                        isDisable={isLoading}
                        preventKeyboardOpen={true}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isLeadSourceShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" && (
                      <span className="label">lead source</span>
                    )}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selLeadSource?.value ? "redBorderRedText" : ""
                      }`}
                    >
                      <SelectDropdown
                        options={
                          leadSources?.data?.length > 0
                            ? from === "subscriptions"
                              ? leadSources.data.filter(s => s.label !== "Company Leads" && s.label !== "IVR")
                              : leadSources.data
                            : []
                        }
                        selectedOption={filters?.selLeadSource}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selLeadSource: selectedValue,
                          })
                        }
                        name="Lead Source"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isGenderShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" && (
                      <span className="label">gender</span>
                    )}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedGender?.value ? "redBorderRedText" : ""
                      }`}
                    >
                      <SelectDropdown
                        options={gender}
                        selectedOption={filters?.selectedGender}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedGender: selectedValue,
                          })
                        }
                        name="Gender"
                        isDisable={isLoading}
                        preventKeyboardOpen={true}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isTransferTypeShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" ? (
                      <span className="label">transfer type</span>
                    ) : null}

                    <div
                      className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                        filters?.selectedTransferType?.value &&
                        "redBorderRedText"
                      }`}
                    >
                      <SelectDropdown
                        options={transfer_type}
                        selectedOption={filters?.selectedTransferType}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedTransferType: selectedValue,
                          })
                        }
                        name="Transfer Type"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isPauseStatusShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" ? (
                      <span className="label">pause status</span>
                    ) : null}

                    <div
                      className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                        filters?.selectedPauseStatus?.value &&
                        "redBorderRedText"
                      }`}
                    >
                      <SelectDropdown
                        options={pause_status}
                        selectedOption={filters?.selectedPauseStatus}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedPauseStatus: selectedValue,
                          })
                        }
                        name="Pause Status"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isExperienceLevelShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" ? (
                      <span className="label">Member Experience Level</span>
                    ) : null}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedExperienceLevel?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdown
                        options={experience_level}
                        selectedOption={filters?.selectedExperienceLevel}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedExperienceLevel: selectedValue,
                          })
                        }
                        name="Member Experience Level"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isPaymentLocationShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" ? (
                      <span className="label">Payment Location</span>
                    ) : null}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedPaymentLocation?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdown
                        options={payment_location}
                        selectedOption={filters?.selectedPaymentLocation}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedPaymentLocation: selectedValue,
                          })
                        }
                        name="Payment Location"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isAllAccessPlanShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" ? (
                      <span className="label">All Access Plan</span>
                    ) : null}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedAllAccessPlan?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdown
                        options={all_access_plan}
                        selectedOption={filters?.selectedAllAccessPlan}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedAllAccessPlan: selectedValue,
                          })
                        }
                        name="All Access Plan"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isPreGymSalesShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" ? (
                      <span className="label">Pre Gym Sales</span>
                    ) : null}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedPreGymSales?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdown
                        options={pre_gym_sales}
                        selectedOption={filters?.selectedPreGymSales}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedPreGymSales: selectedValue,
                          })
                        }
                        name="Pre Gym Sales"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isPriceRangeShow && (
                  <div className="commonWrapperWithLabel">
                    <div className="common-wrapper-between">
                      <div
                        className={`commonWrapper dropdownCommonWrapper ${
                          filters?.selectedPriceRangeFrom?.value
                            ? "redBorderRedText"
                            : ""
                        }`}
                      >
                        <SelectDropdownLabel
                          options={price_ranges}
                          selectedOption={filters?.selectedPriceRangeFrom}
                          setSelectedOption={(selectedValue) =>
                            setFilters({
                              ...filters,
                              selectedPriceRangeFrom: selectedValue,
                            })
                          }
                          name="Price (From)"
                          isDisable={isLoading}
                        />
                      </div>

                      <div
                        className={`commonWrapper dropdownCommonWrapper ${
                          filters?.selectedPriceRangeTo?.value
                            ? "redBorderRedText"
                            : ""
                        }`}
                      >
                        <SelectDropdownLabel
                          options={price_ranges}
                          selectedOption={filters?.selectedPriceRangeTo}
                          setSelectedOption={(selectedValue) =>
                            setFilters({
                              ...filters,
                              selectedPriceRangeTo: selectedValue,
                            })
                          }
                          name="Price (To)"
                          isDisable={isLoading}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {allowedFilters.isLandingPageKeywordShow && (
                  <div className="commonWrapperWithLabel">
                    {from === "subscriptions" ? (
                      <span className="label">checkout source</span>
                    ) : null}

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedCheckoutSource?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdown
                        options={allDropdownData.allLandingPages}
                        selectedOption={filters?.selectedCheckoutSource}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedCheckoutSource: selectedValue,
                          })
                        }
                        name="checkout source"
                        isDisable={isLoading}
                      />
                    </div>
                  </div>
                )}

                {allowedFilters.isSearchShow ? (
                  <div className="commonWrapperWithLabel filter-searchbar-container span2">
                    {from === "subscriptions" ? (
                      <span className="label">search</span>
                    ) : null}

                    <div
                      className={`inputCommonWrapper flexSpacebetween searchBarContainer ${
                        searchFilterApplied ? "redBorderRedText" : ""
                      } ${isLoading ? "disabled" : ""} `}
                    >
                      <input
                        type="search"
                        className="input"
                        placeholder="Search..."
                        value={filters?.searchString}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            searchString: e.target.value,
                          })
                        }
                        disabled={isLoading}
                      />
                      <button
                        type="button"
                        className="button"
                        onClick={onClickSearch}
                        disabled={isLoading}
                      >
                        search
                        <BiSearchIcon />
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CommonFilterStructure;
